
import AddLineIcon from '~/assets/images/add-line-icon.svg?inline'

export default {
  components: {
    AddLineIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
  },
}
